/**
 * The AppContent object
 * @class F2.AppManifest.AppContent
 **/
export default {
	/**
	 * Arbitrary data to be passed along with the app
	 * @property data
	 * @type object
	 * @optional
	 */
	data: {},
	/**
	 * The string of HTML representing the app
	 * @property html
	 * @type string
	 * @required
	 */
	html: '',
	/**
	 * A status message
	 * @property status
	 * @type string
	 * @optional
	 */
	status: ''
};
